import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const websiteColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'website1',
  headerName: 'Website',
  initialHide: true,
};
